import Home from '@/views/home/home.vue';
// import home from '@/views/home/home';
import Login from '@/views/account/Login.vue';
import Callback from '@/views/Callback.vue';
import Register from '@/views/account/Register.vue';
import BroadCast from '@/views/serve/broadcast.vue';
import NotFoundComponent from '@/views/NotFoundComponent.vue';
export var routes = [
    {
        path: '*',
        component: NotFoundComponent
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/register',
        name: 'register',
        component: Login
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/callback',
        name: 'callback',
        component: Callback
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: function () { return import(/* webpackChunkName: "about" */ '@/views/About.vue'); },
        meta: { requiresAuth: true }
    },
    {
        path: '/projectSelect',
        name: 'projectSelect',
        component: function () { return import('@/views/projectSale/projectSelect.vue'); },
        meta: {
            title: '活动',
            requiresAuth: true
        }
    },
    {
        path: '/active',
        name: 'active',
        component: function () { return import('@/views/active/active.vue'); },
        meta: {
            title: '活动',
            requiresAuth: true
        }
    },
    {
        path: '/activeDetail/:id',
        name: 'activeDetail',
        component: function () { return import('@/views/active/activeDetail.vue'); },
        // component: ActiveDetail,//() => import('@/views/active/activeDetail.vue'),
        meta: {
            title: '活动详情', requiresAuth: true
        }
    },
    {
        path: '/serve',
        name: 'serve',
        component: function () { return import('@/views/serve/serve.vue'); },
        meta: {
            title: '服务',
            requiresAuth: true
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        meta: {
            requiresAuth: true
        },
        component: BroadCast
    },
    {
        path: '/repair',
        name: 'repair',
        component: function () { return import('@/views/repair/repair.vue'); },
        meta: {
            title: '工程报修', requiresAuth: true
        }
    },
    {
        path: '/repairForm/:id/:type',
        name: 'repairForm',
        component: function () { return import('@/views/repair/repairForm.vue'); },
        meta: {
            title: '工程报修', requiresAuth: true
        }
    },
    {
        path: '/suggest',
        name: 'suggest',
        component: function () { return import('@/views/suggest/suggest.vue'); },
        meta: {
            title: '投诉咨询', requiresAuth: true
        }
    },
    {
        path: '/suggestForm/:id',
        name: 'suggestForm',
        component: function () { return import('@/views/suggest/suggestForm.vue'); },
        meta: {
            title: '投诉咨询', requiresAuth: true
        }
    },
    {
        path: '/serviceCustom',
        name: 'serviceCustom',
        component: function () { return import('@/views/serve/serviceCustom.vue'); },
        meta: {
            title: '联系客服', requiresAuth: true
        }
    },
    {
        path: '/shop',
        name: 'shop',
        component: function () { return import('@/views/shop/shop.vue'); },
        meta: {
            title: '积分商城',
            requiresAuth: true
        }
    },
    {
        path: '/productDetail/:id',
        name: 'productDetail',
        component: function () { return import('@/views/shop/productDetail.vue'); },
        meta: {
            title: '商品详情', requiresAuth: true
        }
    },
    {
        path: '/user',
        name: 'user',
        component: function () { return import('@/views/user/user.vue'); },
        meta: {
            title: '我的',
            requiresAuth: true
        }
    },
    {
        path: '/projectProgress/:projectId/:year/:month',
        name: 'projectProgress',
        component: function () { return import('@/views/projectProgress/projectProgress.vue'); },
        meta: {
            title: '工程进度', requiresAuth: true
        }
    },
    {
        path: '/progressDetail/:id',
        name: 'progressDetail',
        component: function () { return import('@/views/projectProgress/progressDetail.vue'); },
        meta: {
            title: '工程进展',
        }
    },
    {
        path: '/deliverOrder/:id',
        name: 'deliverOrder',
        component: function () { return import('@/views/deliverOrder/deliverOrder.vue'); },
        meta: {
            title: '交付预约', requiresAuth: true
        }
    },
    {
        path: '/contentDetail/:id',
        name: 'contentDetail',
        meta: { requiresAuth: true },
        component: function () { return import('@/views/home/contentDetail.vue'); }
    },
    {
        path: '/certificate',
        name: 'certificate',
        component: function () { return import('@/views/certificate/certificate.vue'); },
        meta: {
            title: '注册认证', requiresAuth: true
        }
    },
    {
        path: '/my-repairRecords',
        name: 'my-repairRecords',
        component: function () { return import('@/views/member/my-repairRecords.vue'); },
        meta: {
            title: '我的报修',
            requiresAuth: true
        }
    },
    {
        path: '/repairRecordInfo/:id',
        name: 'repairRecordInfo',
        component: function () { return import('@/views/member/repairRecordInfo.vue'); },
        meta: {
            title: '报修详情', requiresAuth: true
        }
    },
    {
        path: '/my-complaintRecords',
        name: 'my-complaintRecords',
        component: function () { return import('@/views/member/my-complaintRecords.vue'); },
        meta: {
            title: '投诉咨询', requiresAuth: true
        }
    },
    {
        path: '/my-address',
        name: 'my-address',
        component: function () { return import('@/views/member/my-address.vue'); },
        meta: {
            title: '收货地址', requiresAuth: true
        }
    },
    {
        path: '/addressEdit/:id',
        name: 'addressEdit',
        component: function () { return import('@/views/member/addressEdit.vue'); },
        meta: {
            title: '地址编辑', requiresAuth: true
        }
    },
    {
        path: '/my-houses',
        name: 'my-houses',
        component: function () { return import('@/views/member/my-houses.vue'); },
        meta: {
            title: '我的房产', requiresAuth: true
        }
    },
    {
        path: '/photoWall/:id',
        name: 'photoWall',
        component: function () { return import('@/views/serve/photoWall.vue'); },
        meta: {
            title: '照片墙', requiresAuth: true
        }
    },
    {
        path: '/coupon',
        name: 'coupon',
        component: function () { return import('@/views/coupon/coupon.vue'); },
        meta: {
            title: '悦福利', requiresAuth: true
        }
    },
    {
        path: '/save-order',
        name: 'save-order',
        component: function () { return import('@/views/shop/save-order.vue'); },
        meta: {
            title: '保存订单', requiresAuth: true
        }
    },
    {
        path: '/my-order',
        name: 'my-order',
        component: function () { return import('@/views/order/my-order.vue'); },
        meta: {
            title: '我的订单', requiresAuth: true
        }
    },
    {
        path: '/order_details/:id',
        name: 'order_details',
        meta: { title: '订单详情', requiresAuth: true },
        component: function () { return import('@/views/order/order-details.vue'); }
    },
    {
        path: '/pay/:id',
        name: 'pay',
        meta: { title: '支付', requiresAuth: true },
        component: function () { return import('@/views/order/pay.vue'); }
    },
    {
        path: '/payment_code',
        name: 'payment_code',
        meta: { title: '设置支付密码', requiresAuth: true },
        component: function () { return import('@/views/order/payment-code.vue'); }
    },
    {
        path: '/productOrder',
        name: 'productOrder',
        meta: { title: '保存订单', requiresAuth: true },
        component: function () { return import('@/views/shop/productOrder.vue'); }
    },
    {
        path: '/complaintRecordInfo/:id',
        name: 'complaintRecordInfo',
        meta: { title: '投诉详情', requiresAuth: true },
        component: function () { return import('@/views/member/complaintRecordInfo.vue'); }
    },
    {
        path: '/complaintComment/:id',
        name: 'complaintComment',
        meta: { title: '评价', requiresAuth: true },
        component: function () { return import('@/views/member/complaintComment.vue'); }
    },
    {
        path: '/repairComment/:id',
        name: 'repairComment',
        meta: { title: '报修评价', requiresAuth: true },
        component: function () { return import('@/views/member/repairComment.vue'); }
    },
    {
        path: '/houseCard/:id',
        name: 'houseCard',
        meta: { title: '产证查询', requiresAuth: true },
        component: function () { return import('@/views/home/cert/houseCard.vue'); }
    },
    {
        path: '/welfare/:id',
        name: 'welfare',
        meta: { title: '生日福利', requiresAuth: true },
        component: function () { return import('@/views/home/welfare.vue'); }
    },
    {
        path: '/projectSale',
        name: 'projectSale',
        meta: { title: '微楼书', requiresAuth: true },
        component: function () { return import('@/views/projectSale/projectSale.vue'); }
    },
    {
        path: '/onSale/:id',
        name: 'onSale',
        meta: { title: '', requiresAuth: true },
        component: function () { return import('@/views/projectSale/onSale.vue'); }
    },
    {
        path: '/science',
        name: 'science',
        meta: { title: '科普知识', requiresAuth: true },
        component: function () { return import('@/views/serve/science.vue'); }
    },
    {
        path: '/scienceZx',
        name: 'scienceZx',
        meta: { title: '科普知识', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceZx.vue'); }
    },
    {
        path: '/scienceJq',
        name: 'scienceJq',
        meta: { title: '交房流程', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceJq.vue'); }
    },
    {
        path: '/scienceWx',
        name: 'scienceWx',
        meta: { title: '维修小百科', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceWx.vue'); }
    },
    {
        path: '/scienceYf',
        name: 'scienceYf',
        meta: { title: '验房小百科', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceYf.vue'); }
    },
    {
        path: '/lifeHelp',
        name: 'lifeHelp',
        meta: { title: '生活服务', requiresAuth: true },
        component: function () { return import('@/views/serve/lifeHelp.vue'); }
    },
    {
        path: '/serveMsg',
        name: 'serveMsg',
        meta: { title: '便民服务信息', requiresAuth: true },
        component: function () { return import('@/views/serve/serveMsg.vue'); }
    },
    {
        path: '/my-integral',
        name: 'my-integral',
        meta: { title: '我的积分', requiresAuth: true },
        component: function () { return import('@/views/member/my-integral.vue'); }
    },
    {
        path: '/integral-rule',
        name: 'integral-rule',
        meta: { title: '积分规则', requiresAuth: true },
        component: function () { return import('@/views/member/integral-rule.vue'); }
    },
    {
        path: '/my-appoint',
        name: 'my-appoint',
        meta: { title: '我的预约', requiresAuth: true },
        component: function () { return import('@/views/member/my-appoint.vue'); }
    },
    {
        path: '/my-appointDetail/:id',
        name: 'my-appointDetail',
        meta: { title: '我的预约详情', requiresAuth: true },
        component: function () { return import('@/views/member/my-appointDetail.vue'); }
    },
    {
        path: '/activeApply/:id',
        name: 'activeApply',
        meta: { title: '活动报名', requiresAuth: true },
        component: function () { return import('@/views/active/activeApply.vue'); }
    },
    {
        path: '/activeForm/:id/:price/:isUpLoad',
        name: 'activeForm',
        meta: {
            title: '活动报名',
            requiresAuth: true
        },
        component: function () { return import('@/views/active/activeForm.vue'); }
    },
    {
        path: '/activeApplySuc',
        name: 'activeApplySuc',
        meta: { title: '报名成功', requiresAuth: true },
        component: function () { return import('@/views/active/activeApplySuc.vue'); }
    },
    {
        path: '/my-active',
        name: 'my-active',
        meta: { title: '我的活动', requiresAuth: true },
        component: function () { return import('@/views/member/my-active.vue'); }
    },
    {
        path: '/order',
        name: 'order',
        meta: { title: '交付预约', requiresAuth: true },
        component: function () { return import('@/views/deliverOrder/order.vue'); }
    },
    {
        path: '/my-activeDetail/:id',
        name: 'my-activeDetail',
        meta: { title: '活动详情', requiresAuth: true },
        component: function () { return import('@/views/member/my-activeDetail.vue'); }
    },
    {
        path: '/question',
        name: 'question',
        meta: { title: '问卷调查', requiresAuth: true },
        component: function () { return import('@/views/home/question.vue'); }
    },
    {
        path: '/qstDetail/:id',
        name: 'qstDetail',
        meta: { title: '问卷调查', requiresAuth: true },
        component: function () { return import('@/views/home/qstDetail.vue'); }
    },
    {
        path: '/my-coupon',
        name: 'my-coupon',
        meta: { title: '我的卡券', requiresAuth: true },
        component: function () { return import('@/views/member/my-coupon.vue'); }
    },
    {
        path: '/answerDetail/:id/:qid',
        name: 'answerDetail',
        meta: { title: '问卷查看', requiresAuth: true },
        component: function () { return import('@/views/home/answerDetail.vue'); }
    },
    {
        path: '/couponDetail/:id',
        name: 'couponDetail',
        meta: { title: '优惠券详情', requiresAuth: true },
        component: function () { return import('@/views/member/couponDetail.vue'); }
    },
    {
        path: '/cert-houses',
        name: 'cert-houses',
        meta: { title: '我的认证', requiresAuth: true },
        component: function () { return import('@/views/home/cert/houses.vue'); }
    },
    {
        path: '/afficheDetail',
        name: 'afficheDetail',
        meta: { title: '公告详情', requiresAuth: true },
        component: function () { return import('@/views/home/afficheDetail.vue'); }
    },
    {
        path: '/serveMsgDetail/:id',
        name: 'serveMsgDetail',
        meta: { title: '服务详情', requiresAuth: true },
        component: function () { return import('@/views/serve/serveMsgDetail.vue'); }
    },
    {
        path: '/character',
        name: 'character',
        meta: { title: '会员绑定', requiresAuth: true },
        component: function () { return import('@/views/certificate/character.vue'); }
    },
    {
        path: '/owner_select',
        name: 'owner_select',
        meta: { title: '选择业主身份', requiresAuth: true },
        component: function () { return import('@/views/certificate/owner_select.vue'); }
    },
    {
        path: '/un_owner',
        name: 'un_owner',
        meta: { title: '非业主注册', requiresAuth: true },
        component: function () { return import('@/views/certificate/un_owner.vue'); }
    },
    {
        path: '/owner',
        name: 'owner',
        meta: { title: '业主注册', requiresAuth: true },
        component: function () { return import('@/views/certificate/owner.vue'); }
    },
    {
        path: '/owner_family',
        name: 'owner_family',
        meta: { title: '家庭成员等副卡绑定', requiresAuth: true },
        component: function () { return import('@/views/certificate/owner_family.vue'); }
    },
    {
        path: '/photos',
        name: 'photos',
        meta: { title: '照片墙相册', requiresAuth: true },
        component: function () { return import('@/views/serve/photos.vue'); }
    },
    {
        path: '/selectCity',
        name: 'selectCity',
        meta: { title: '工程进度', requiresAuth: true },
        component: function () { return import('@/views/projectProgress/selectCity.vue'); }
    },
    {
        path: '/selectTimeline/:id',
        name: 'selectTimeline',
        meta: { title: '工程进度', requiresAuth: true },
        component: function () { return import('@/views/projectProgress/selectTimeline.vue'); }
    },
    {
        path: '/loadingPage',
        name: 'loadingPage',
        meta: { title: '加载中', requiresAuth: true },
        component: function () { return import('@/views/loadingPage/loadingPage.vue'); }
    },
    {
        path: '/profileEdit',
        name: 'profileEdit',
        meta: { title: '资料修改', requiresAuth: true },
        component: function () { return import('@/views/member/profileEdit.vue'); }
    },
    {
        path: '/scienceYfList',
        name: 'scienceYfList',
        meta: { title: '验房百科', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceYfList.vue'); }
    },
    {
        path: '/scienceJqList',
        name: 'scienceJqList',
        meta: { title: '甲醛标准', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceJqList.vue'); }
    },
    {
        path: '/scienceList/:title',
        name: 'scienceList',
        meta: { title: '科普知识', requiresAuth: true },
        component: function () { return import('@/views/serve/scienceList.vue'); }
    },
    {
        path: '/welfareNotice',
        name: 'welfareNotice',
        meta: { title: '生日福利', requiresAuth: true },
        component: function () { return import('@/views/home/welfareNotice.vue'); }
    },
    {
        path: '/business/:shopId',
        name: 'business',
        meta: { title: '合作商家', requiresAuth: true },
        component: function () { return import('@/views/member/business/business.vue'); }
    },
    {
        path: '/ticketList/:shopId',
        name: 'ticketList',
        meta: { title: '收券记录', requiresAuth: true },
        component: function () { return import('@/views/member/business/ticketList.vue'); }
    },
    {
        path: '/broadcastDetail/:id',
        name: 'broadcastDetail',
        meta: { title: '小区广播详情', requiresAuth: true },
        component: function () { return import('@/views/serve/broadcastDetail.vue'); }
    },
    {
        path: '/workSheets',
        name: 'workSheets',
        meta: { title: '工单管理', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/workSheets.vue'); }
    },
    {
        path: '/noticeSheet',
        name: 'noticeSheet',
        meta: { title: '消息', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/noticeSheet.vue'); }
    },
    {
        path: '/userSheet',
        name: 'userSheet',
        meta: { title: '用户', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/userSheet.vue'); }
    },
    {
        path: '/workSheetDetail/:id',
        name: 'workSheetDetail',
        meta: { title: '工单详情', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/workSheetDetail.vue'); }
    },
    {
        path: '/my-notice',
        name: 'my-notice',
        meta: { title: '我的消息', requiresAuth: true },
        component: function () { return import('@/views/member/my-notice.vue'); }
    },
    {
        path: '/userCoupon/:id/:couponId',
        name: 'userCoupon',
        meta: { title: '优惠券', requiresAuth: true },
        component: function () { return import('@/views/coupon/userCoupon.vue'); }
    },
    {
        path: '/storeList',
        name: '店铺列表',
        meta: { title: '', requiresAuth: true },
        component: function () { return import('@/views/member/business/storeList.vue'); }
    },
    {
        path: '/businessDetail/:code/:shopId',
        name: 'businessDetail',
        meta: { title: '', requiresAuth: true },
        component: function () { return import('@/views/member/business/businessDetail.vue'); }
    },
    {
        path: '/ticketDetail/:id',
        name: 'ticketDetail',
        meta: { title: '', requiresAuth: true },
        component: function () { return import('@/views/member/business/ticketDetail.vue'); }
    },
    // {
    //     path: '/paiDanDetail/:id',
    //     name: 'paiDanDetail',
    //     meta: {title: '派单', requiresAuth: true},
    //     component: () => import('@/views/member/workSheet/paiDanDetail.vue')
    // },
    {
        path: '/activeScan',
        name: 'activeScan',
        meta: { title: '活动扫码', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/activeScan.vue'); }
    },
    {
        path: '/scanList',
        name: 'scanList',
        meta: { title: '活动扫码', requiresAuth: true },
        component: function () { return import('@/views/member/workSheet/scanList.vue'); }
    },
    {
        path: '/signIn/:code',
        name: 'signIn',
        meta: { title: '活动签到', requiresAuth: true },
        component: function () { return import('@/views/member/activity/signIn.vue'); }
    },
    {
        path: '/otherOwner/:id',
        name: 'otherOwner',
        meta: { title: '交付预约', requiresAuth: true },
        component: function () { return import('@/views/deliverOrder/otherOwner.vue'); }
    },
    {
        path: '/deliverData/:id',
        name: 'deliverData',
        meta: { title: '交付预约', requiresAuth: true },
        component: function () { return import('@/views/deliverOrder/deliverData.vue'); }
    },
    // {
    //     path: '/repair-detail/:id',
    //     name: 'repair-detail',
    //     meta: {
    //         title: '工单详情',
    //         requiresAuth: true
    //     },
    //     component: () => import('@/views/member/workSheet/repair/repair-detail.vue')
    // },
    {
        path: '/member-workSheetDetail/:id',
        name: 'member-workSheetDetail',
        meta: {
            title: '工单详情',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/member-workSheetDetail.vue'); }
    },
    {
        path: '/qscode/:projectId',
        name: 'qscode',
        meta: {
            title: '',
            requiresAuth: true
        },
        component: function () { return import('@/views/other/qscode.vue'); }
    },
    {
        path: '/workOrder-task',
        name: 'workOrder-task',
        meta: {
            title: '工单任务',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/task/workOrder-task.vue'); }
    },
    {
        path: '/consult',
        name: 'consult',
        meta: {
            title: '咨询工单',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/consult/index.vue'); }
    },
    {
        path: '/complaint',
        name: 'complaint',
        meta: {
            title: '投诉工单',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/complaint/index.vue'); }
    },
    {
        path: '/repair-orders',
        name: 'repair-orders',
        meta: {
            title: '报修工单',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/repair/index.vue'); }
    },
    {
        path: '/workOrder-management',
        name: 'workOrder-management',
        meta: {
            title: '工单管理',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/management/index.vue'); }
    },
    {
        path: '/workOrder-split/:id',
        name: 'workOrder-split',
        meta: {
            title: '拆分工单',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/split/index.vue'); }
    },
    {
        path: '/house/detail/:roomId',
        name: 'house-detail',
        meta: {
            title: '房产详情',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/house/detail.vue'); }
    },
    {
        path: '/create-workOrder',
        name: 'create-workOrder',
        meta: {
            title: '提交工单',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/workSheet/create-workOrder.vue'); }
    },
    {
        path: '/pc-download/:roomOwnerId',
        name: 'pc-download',
        meta: {
            title: '产证下载',
            requiresAuth: true
        },
        component: function () { return import('@/views/member/pc-download.vue'); }
    },
    {
        path: '/delivery/:id',
        name: "delivery",
        meta: {
            title: '交付预约',
            requiresAuth: true
        },
        component: function () { return import('@/views/delivery/delivery.vue'); }
    },
    {
        path: '/delivery-owner/:deliveryPlanId',
        name: "delivery-owner",
        meta: {
            title: '交付预约',
            requiresAuth: true
        },
        component: function () { return import('@/views/delivery/delivery-owner.vue'); }
    },
    {
        path: '/delivery-data/:roomId/:deliveryPlanId/:step',
        name: "delivery-data",
        meta: {
            title: '交付预约',
            requiresAuth: true
        },
        component: function () { return import('@/views/delivery/delivery-data.vue'); }
    },
    {
        path: '/delivery-appointment/:recordId',
        name: "delivery-appointment",
        meta: {
            title: '交付预约',
            requiresAuth: true
        },
        component: function () { return import('@/views/delivery/delivery-appointment.vue'); }
    },
    {
        path: '/deliveryReceiveConfirmation/:recordId',
        name: "deliveryReceiveConfirmation",
        meta: {
            title: '房屋交付文件确认',
            requiresAuth: true
        },
        component: function () { return import('@/views/delivery/deliveryReceiveConfirmation.vue'); }
    },
];
